import axios from "axios";
import config from "../config/settings.js";
axios.defaults.withCredentials = true;
axios.defaults.baseURL = config.APP_URL;
import Cookies from "js-cookie";

const apiHelper = {
    methods: {

        postLogin(api, data) {
            return data
                .post(api, {
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then((response) => {
                    return {
                        result: "success",
                        code: response.status,
                        response: response.data,
                    }
                })
                .catch((error) => {
                    return {
                        result: "fail",
                        code: error.status,
                        response: error.response.data
                    }
                });


        },
        postData(api, data) {
            return data
                .post(api, {
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + sessionStorage.getItem("access_token")
                    },
                })
                .then((response) => {
                    // this.user = this.decryptData(response.data.data);
                    return {
                        result: "success",
                        code: response.status,
                        response: response.data,
                    }
                })
                .catch((error) => {
                    return {
                        result: "fail",
                        code: error.status,
                        response: error.response.data
                    }
                });


        },
        putData(api, data) {
            return data
                .put(api, {
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + sessionStorage.getItem("access_token")
                    },
                })
                .then((response) => {
                    return {
                        result: "success",
                        code: response.status,
                        response: response.data,
                    }
                })
                .catch((error) => {
                    return {
                        result: "fail",
                        code: error.status,
                        response: error.response.data
                    }
                });
        },
        deleteData(api) {
            return axios
                .delete(api, {
                    headers: {
                        Authorization: "Bearer " + sessionStorage.getItem("access_token"),
                    },
                })
                .then((response) => {
                    // this.user = this.decryptData(response.data.data);
                    return {
                        result: "success",
                        code: response.status,
                        response: response.data,
                    }
                })
                .catch((error) => {
                    return {
                        result: "fail",
                        code: error.status,
                        response: error.response.data
                    }
                });
        },
        async getData(api) {
            return axios
                .get(api, {
                    headers: {
                        Authorization: "Bearer " + sessionStorage.getItem("access_token"),
                    },
                })
                .then((response) => {
                    // this.user = this.decryptData(response.data.data);
                    return {
                        result: "success",
                        code: response.status,
                        response: response.data,
                    }
                })
                .catch((error) => {
                    return {
                        result: "fail",
                        code: error.status,
                        response: error.response.data
                    }
                });

        },
    },

}

export default apiHelper;